import React, {FC} from 'react';
import {observer} from 'mobx-react-lite';
import {CalendarBox} from './calendarBox/calendarBox';
import './gantt.css';

export const CalendarView: FC = observer(() => {
  return <CalendarBox />;
});
